import { SelectOptionType } from 'utils/react-table';
import VenueTypeDto, { mapVenueTypeToEnumOption } from './venue-type-dto';
import { EnumOption } from 'common/enum-value';
import TournamentDto from './tournament-dto';
import CityDto from './city-dto';

type VenueDto = {
    id: number;
    name: string;
    description: string;
    city: string;
    country: string;
    countryId: number;
    address: string;
    addressLine: string;
    state: string;
    postalCode: string;
    imageUrl: string;
    latitude: number | null;
    longitude: number | null;
    ifesId: string;
    url: string;
    canShowInSubscription: boolean;
    isVenueAssigned?: boolean;
    venueTypeId?: number;
    venueType?: VenueTypeDto;
    timeZone: string;
    tournaments: TournamentDto[];
    hostCityId?: number;
    hostCity?: CityDto;
    created?: Date;
    modified?: Date;
};

let VenueTypeTypeOptions: EnumOption[] = [{ value: 0, label: 'undefined' }];
export function initializeVenueTypeOptions(venueTypes: Array<VenueTypeDto>) {
    VenueTypeTypeOptions = mapVenueTypeToEnumOption(venueTypes);
}
export { VenueTypeTypeOptions };

export const mapVenueToSelectOption = (venues: Array<VenueDto>): Array<SelectOptionType> => {
    return venues.map((venue) => ({ value: venue.id, label: venue.name }));
};

export const mapVenueToAddressSelectOption = (venues: Array<VenueDto>): Array<SelectOptionType> => {
    return venues.map((venue) => ({
        value: venue.id,
        label: `${venue.name} - ${venue.address || venue.addressLine || ''}`,
    }));
};

export const mapVenueToCountryCitySelectOption = (venues: Array<VenueDto>): Array<SelectOptionType> => {
    return venues.map((venue) => {
        const parts = [venue.country, venue.city, venue.timeZone ? `time: ${venue.timeZone}` : null];
        const locationDetails = parts.filter(Boolean).join(', ');

        return {
            value: venue.id,
            label: `${venue.name} (${locationDetails})`,
        };
    });
};

export default VenueDto;
